module.exports = __webpack_public_path__ + "img/leverage-2.7a5e9496.png";